import {useCallback,useEffect,useRef} from 'react';
import AuthRepo from '@/core/repos/auth.repo';
import TokenRepo from '@/core/repos/token.repo';
import container from '@/lib/di/container';
import {useFactoryRuntimeSettings} from '@/core/stores/factory-runtime-settings.store';
import {configurationPermissions,ConfigurationAction,ConfigurationModule} from '@/core/utils/configuration-permissions';
const authRepo=container.get(AuthRepo);
const tokenRepo=new TokenRepo();
/** Fence requests and late responses across claim, factory, user and token changes. */
export function useConfigurationPermissions(){
 const user=authRepo.useDetails();const claims=authRepo.useClaims();const runtime=useFactoryRuntimeSettings();
 const access=configurationPermissions(user,claims);
 const sessionKey=JSON.stringify([user?.id,user?.userName,user?.waterFactoryId,runtime.contextId,claims.map(claim=>claim.id).sort()]);
 const token=tokenRepo.getToken();const generation=useRef(0);
 const current=useRef({sessionKey,token,access,generation:0});
 if(current.current.sessionKey!==sessionKey||current.current.token!==token)++generation.current;
 current.current={sessionKey,token,access,generation:generation.current};
 const active=useRef(true);useEffect(()=>{active.current=true;return()=>{active.current=false;};},[]);
 const guard=useCallback((module:ConfigurationModule,action:ConfigurationAction)=>{
  const captured=current.current;
  return ()=>active.current&&captured.access[module][action]&&current.current.generation===captured.generation&&current.current.sessionKey===captured.sessionKey&&current.current.access[module][action]&&tokenRepo.getToken()===captured.token;
 },[]);
 return {access,sessionKey,guard};
}
